import Vue from 'vue'
import {BootstrapVue, BootstrapVueIcons, componentsPlugin, IconsPlugin} from 'bootstrap-vue'

import './registerServiceWorker'
import router from './router'
import store from './store'

// import bootstrap vue
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'
// register bootstrap vue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(BootstrapVueIcons)

// register vuelidate
import Vuelidate from 'vuelidate'

Vue.use(Vuelidate)

Vue.config.productionTip = false

// only to define formatter language value
export const i18n = {}


// axios
import axios from "axios";
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/axios'

axios.defaults.baseURL = 'https://diamondnr.ir';

export const dashboardLink = 'https://dash.diamondnr.ir';
export const siteLink = 'https://diamondnr.ir';

// import main requirements
import '@moeinmdn/mixitweb-front-modules/src/plugin/class/MainRequirements'

// register miw-components
import './plugin/miw-components/indexComponents'
import App from './App.vue'

// authenticate user
store.dispatch('Authentication/attemptLogin').then(async () => {

    if (process.env.NODE_ENV != 'development') {
        await store.dispatch('SiteServiceManager/isProjectExpire')
    }

    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount('#app')

})
